import { useNavigate, Link } from "react-router-dom";
import { LogOut, ShieldCheck, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import FiskLogo from "@/components/FiskLogo";
import NotificationsBell from "@/components/NotificationsBell";
import { useAuth } from "@/context/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 bg-black text-white border-b border-neutral-900"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <FiskLogo to={user && user.role ? "/" : "/login"} />

        {user && user.role && (
          <nav className="flex items-center gap-2 sm:gap-3">
            <Link
              to="/"
              data-testid="nav-books-link"
              className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 text-sm rounded-sm hover:bg-neutral-900 transition-colors"
            >
              <BookOpen className="w-4 h-4" /> Cursos
            </Link>
            {user.role === "admin" && (
              <Link
                to="/admin"
                data-testid="nav-admin-link"
                className="inline-flex items-center gap-2 px-3 py-1.5 text-sm rounded-sm border border-[#E30613] text-[#E30613] hover:bg-[#E30613] hover:text-white transition-colors"
              >
                <ShieldCheck className="w-4 h-4" /> Painel Admin
              </Link>
            )}
            {user.role !== "admin" && <NotificationsBell />}
            <span className="hidden md:block text-sm text-neutral-400 px-3 border-l border-neutral-800">
              {user.name}
            </span>
            <Button
              data-testid="logout-button"
              onClick={handleLogout}
              variant="ghost"
              className="text-white hover:bg-neutral-900 rounded-sm"
              size="sm"
            >
              <LogOut className="w-4 h-4 mr-1" /> Sair
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
}
